/*
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-27 11:30:29
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-02-10 14:45:56
 * @FilePath: /lobby/src/common/request.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { BUS, POPUP } from '@/event/EventCenter'
import { useLanguagesStore } from '@/stores/languages.js'
import { useUserStore } from '@/stores/user.js'
import { ISACTIVE } from '@/utils/helper'
import axios from 'axios'
import { showFailToast, showToast } from 'vant'
import { getLocalStorage, Key } from './localStorage'
import dayjs from 'dayjs'

axios.defaults.timeout = 10000
// axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'
// axios.defaults.headers['Authorization'] = '12345'
// axios.defaults.headers['Accept-Language'] = 'en'

axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL //'https://lobby-api.megalake.games' // dev
// axios.defaults.baseURL = 'https://l-api.vivagameclub.com' // pro

console.log(`api: ${axios.defaults.baseURL}`)

axios.interceptors.request.use(
  function (config) {
    config.myTimestamp = Date.now()
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers['lang'] = useLanguagesStore().currentLanguageCode
    const user = useUserStore()
    if (user.token.length > 0) {
      config.headers['token'] = user.token
    }
    if (config.url.includes('/v1')) {
      // config.baseURL = 'http://192.168.1.15:7001'
      config.baseURL = import.meta.env.VITE_API_GAME_URL
      // config.headers['token'] = '57fcc4663f894d9388677d640662882ff3b90b55fefd4be1b3367b91200b8dc4'
    }

    console.log(`%c>request:`, 'background: yellow;', config.url, config)
    return config
  },
  function (err) {
    console.error('request error:', err)
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    let duration = Date.now() - response.config.myTimestamp
    console.log(`%c<response:`, 'background: pink', duration + 'ms', response.config.url, response)
    if (!response.data.success) {
      showFailToast({
        message: `${response.data.message}`,
        wordBreak: 'break-word',
        duration: 5000
      })
      return Promise.reject(response.data)
    }
    const token = response.headers['token']
    if (token && token.length > 0) {
      const user = useUserStore()
      user.setToken(token)
    }
    return response
  },
  function (err) {
    console.error(`request failed:\ncode=${err.code}\nmessage=${err.message}`)
    // 超出 2xx 范围的状态码都会触发该函数。
    if (!err.response) {
      showFailToast({
        message: `${err.message}`,
        className: 'toast_success_50',
        wordBreak: 'break-word',
        duration: 5000
      })
    } else if (err.response.status === 401) {
      // showToast({
      //   message: `not login`
      // })
      if (ISACTIVE == 'true') {
        // window.bridge.$emit(BUS.SHOW_POPUP, { from: '401', to: POPUP.REGISTER, show: true })
        // window.bridge.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false })
      } else {
        const todayShowed = getLocalStorage(Key.todayShowed) == dayjs().format('YYYY-MM-DD')
        if (!todayShowed) return
        window.bridge.$emit(BUS.SHOW_POPUP, { from: '401', to: POPUP.LOGIN, show: true })
      }
    } else {
      showToast({
        message: `${err.message}`,
        wordBreak: 'break-word',
        duration: 3000
      })
    }

    return Promise.reject(err)
  }
)

function post(url, data = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, config)
      .then((res) => {
        resolve(res.data.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export { post }
